<template>
  <DBox
    :id="'cmp-royalty-statement-sidewindow-payment'"
    :addButton="false"
    :noSeparator="true"
  >
    <NTable
      class="dbox1"
      id="cmp-royalty-statement-sidewindow-single-payment"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('payment_date')">
            <span :title="item['payment_date']" class="txtov">{{
              item["payment_date"]
            }}</span>
          </td>

          <td v-bind="tdcon('payment_reference')">
            <span>{{ item["payment_reference"] }}</span>
          </td>
          <td v-bind="tdcon('payment_method')">
            <span>{{ paymentMethodText }}</span>
          </td>
          <td v-bind="tdcon('notes')">
            <span class="txtov">{{ item["notes"] }}</span>
          </td>
          <td v-bind="tdcon('payment_amount')">
            <div class="ut-flex ut-jbetween">
              <span>{{ $dft.curr(item["payment_amount"]) }}</span>
              <div class="dt-icon-container">
                <img
                  @click.stop="(e) => onStatementEditClick(item)"
                  src="static/icons/edit-blue.svg"
                  class="dt-icon v5 s2"
                  :alt="$t('edit_statement')"
                  :title="$t('edit_statement')"
                />
              </div>
            </div>
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => onDeletePayment()"
              class="dt-icon v5 s2"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { JSONX } from "../../../../utility";
import { AccountsService } from "../../services/accounts.service";

export default {
  props: {
    selectedStatementDetails: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  mounted: async function () {
    const res = await AccountsService.RPpaymentinfomodaldata(
      this.$route?.params?.statement_id
    );
    this.rpPaymentInfoModalData = res.data.modal_data;
  },
  data: () => ({
    rpPaymentInfoModalData: null,
    textFieldConfig: {
      height: 42,
      showEditIconOnHover: false,
      box: true,
      showValidationIcons: true,
    },

    tableConfig: createNTableConfig({
      headerStyle: 3,
      fullHeight: true,
      headerHeight: 32,
    }),
  }),
  computed: {
    Headers: () => [
      createTableHeader("payment_date", { mw: 120 }),
      createTableHeader("payment_reference", {}),
      createTableHeader("payment_method", {}),
      createTableHeader("notes", { f: 3 }),
      createTableHeader("payment_amount", {}),
      createTableHeader("options", { text: false, mw: 30 }),
    ],
    list: function () {
      console.log({'payment.vue:109 this.selectedStatementDetails' : this.selectedStatementDetails});
      return JSONX.tryParse(
        this.selectedStatementDetails?.response?.rp?.json_data
      )?.success
        ? [
            JSONX.tryParse(
              this.selectedStatementDetails?.response?.rp?.json_data
            )?.result,
          ]
        : [];
    },
    paymentInfo() {
      return this.list?.[0];
    },
    paymentMethodText() {
      console.log("this.rpPaymentInfoModalData", this.rpPaymentInfoModalData);
      return this.rpPaymentInfoModalData?.payment_methods?.find((pm) => {
        return pm?.payment_method_id === this.paymentInfo?.payment_method;
      })?.payment_method_name;
    },
  },
  methods: {
    onDeletePayment() {
      this.$emit("deleteClicked");
    },
    onStatementEditClick(item) {
      this.$emit("editClicked", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-royalty-statement-sidewindow-payment {
  .dt-ntable {
    --row-bottom-border-color: transparent;
    --ntable-last-bb: transparent;
  }

  .dt-ntable tbody tr:last-child {
    border-bottom: transparent !important;
  }
}
</style>